import { defaultProcessTextWithoutLinks } from 'app/utility/textProcessing';
import { IServicePreview } from 'app/interfaces/services';
import Link from 'next/link';
import classNames from 'classnames';
import { getServiceUrl } from 'app/utility/navigation';
import ButtonCTA from 'app/components/common/FeedbackModal/ButtonCTA';
import { getServiceSubject } from 'app/utility/forms';
import ImageBg from 'app/components/common/ImageBg';

export interface IServiceFeaturedCardProps {
  data: IServicePreview;
}

export default function ServiceFeaturedCard({
  data
}: IServiceFeaturedCardProps) {
  const { name, description_preview, image_preview, specialists } = data;

  const specialistList =
    specialists?.filter(item => item.image_preview?.[0]?.url)?.slice(0, 4) ||
    [];

  return (
    <Link
      href={getServiceUrl(data)}
      className="group block relative rounded bg-brown overflow-hidden"
    >
      <div className="relative pb-[133%] lg:pb-[180%] rounded overflow-hidden isolate">
        {!!image_preview?.url && (
          <div className="absolute inset-0 rounded group-hover:scale-105 transition-transform duration-700">
            <ImageBg
              src={image_preview.url}
              alt={image_preview.alt || ''}
              placeholderDataURL={image_preview.placeholder_data_url}
              fill
              sizes="(min-width: 768px) 50vw, (min-width: 1024px) 25vw, 100vw"
              className="object-cover rounded"
            />
            <div className="absolute inset-0 bg-black opacity-30 rounded"></div>
          </div>
        )}
      </div>
      <div className="absolute inset-0 p-3 flex items-end text-white">
        <div className="flex flex-col gap-17 xl:gap-7">
          <div className="flex flex-col gap-4">
            {!!name && <div className="text-h1">{name}</div>}
            <div className="with-touch:max-h-none with-touch:overflow-visible with-hover:max-h-0 with-hover:overflow-hidden group-hover:max-h-[600px] transition-[max-height] duration-600 group-hover:duration-1000 ease-out group-hover:ease-ease-custom">
              <div className="flex flex-col gap-4 with-touch:opacity-100 with-hover:opacity-0 group-hover:opacity-100 transition-opacity duration-600 group-hover:delay-200">
                {!!description_preview && (
                  <div
                    className="text-p3 flex flex-col gap-[1em]"
                    dangerouslySetInnerHTML={{
                      __html:
                        defaultProcessTextWithoutLinks(description_preview)
                    }}
                  ></div>
                )}
                {!!specialistList?.length && (
                  <div className="flex">
                    {specialistList.map((specialist, index) => {
                      return (
                        <div
                          key={index}
                          className={classNames('w-10', { '-ml-2': index > 0 })}
                        >
                          <div className="relative pb-[140%] bg-brown rounded">
                            <ImageBg
                              src={specialist.image_preview[0].url}
                              alt={specialist.name}
                              fill
                              className="object-cover rounded opacity-80"
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1 with-touch:opacity-100 with-hover:opacity-0 group-hover:opacity-100 transition-opacity duration-400">
            <div>
              <button
                type="button"
                className="button-default button-trans w-full lowercase"
              >
                Подробнее
              </button>
            </div>
            <ButtonCTA
              subject={getServiceSubject(data)}
              className="button-default button-green with-touch:button-green with-hover:button-trans with-hover:hover:button-green w-full lowercase"
            >
              Записаться
            </ButtonCTA>
          </div>
        </div>
      </div>
    </Link>
  );
}
